import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import QrPreview from './QrPreview'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const QrCodeGenerator = () => {
  useDocumentMeta({
    title: 'Gerador de QR Code Online e Grátis  jarder.dev',
    description:
      'Gere QR Code a partir de qualquer texto ou link, com prévia ' +
      'instantânea e download em PNG. Grátis, direto no navegador.',
  })

  const [text, setText] = useState('https://jarder.dev')
  const [value, setValue] = useState('https://jarder.dev')

  const generate = () => {
    setValue(text)
    trackEvent('tool_generate', { tool: 'qrcode' })
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Gerador de QR Code</h1>
      <p className="tool-disclaimer">
        Cole um link ou qualquer texto e gere um QR Code na hora  tudo
        processado no seu navegador.
      </p>

      <div className="tool-field">
        <label htmlFor="qr-text">Texto ou link</label>
        <input
          id="qr-text"
          type="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
      </div>

      <button type="button" className="tool-button" onClick={generate}>
        Gerar QR Code
      </button>

      <QrPreview value={value} filename="qrcode.png" />

      <div className="tool-info-section">
        <h2>Usos comuns</h2>
        <p>
          Um QR Code pode conter qualquer texto: um link de site, um
          número de telefone, uma mensagem, dados de Wi-Fi ou um
          endereço. É lido apontando a câmera do celular, sem precisar
          de aplicativo específico na maioria dos aparelhos atuais. Bom
          para cardápios, embalagens, materiais impressos, crachás de
          evento ou qualquer lugar onde digitar um link longo seja
          inconveniente.
        </p>
      </div>
    </div>
  )
}

export default QrCodeGenerator
